export const OffWhite = "#EBE1D8";
export const Green = "#0A402D";
export const Brown = "#7B352B";
export const DarkOrange = "#EB6132";
export const Orange = "#ed8448";

export const Cream = "#ECCB88";
export const Burgundy = "#501C2C";
export const Carmine = "#D7003F";
export const Grey = "#C7C7C7";
export const DarkGrey = "#1A1A1A";
export const DarkGrey2 = "#212121";
export const NeonGreen = "#00FF44";

export const Pink = "#F951FF";
export const DarkPink = "rgb(220,79,255, 1)";

export const DeepBlue = "#2123C7";
export const Blue = "#3B96FF";
export const Blue05 = "rgb(26,133,255, 0.5)";
export const Blue025 = "rgb(26,133,255, 0.25)";

export const Purple = "rgb(136,0,255, 1)";
export const Purple05 = "rgb(136,0,255, 0.5)";
export const Violet = "#8B5CF6";
export const Yellow = "rgb(233,205,31, 1)";
export const DarkYellow = "#EBB436";

export const Teal = "#00CED1";
export const Teal05 = "rgba(0, 206, 209, 0.5)";
export const Teal04 = "rgba(0, 206, 209, 0.4)";
export const Teal03 = "rgba(0, 206, 209, 0.3)";
export const Teal015 = "rgba(0, 206, 209, 0.15)";
export const Teal01 = "rgba(0, 206, 209, 0.1)";
export const Teal005 = "rgba(0, 206, 209, 0.05)";

export const Violet05 = "rgba(139, 92, 246, 0.5)";
export const Violet04 = "rgba(139, 92, 246, 0.4)";
export const Violet03 = "rgba(139, 92, 246, 0.3)";
export const Violet02 = "rgba(139, 92, 246, 0.2)";
export const Violet015 = "rgba(139, 92, 246, 0.15)";
export const Violet01 = "rgba(139, 92, 246, 0.1)";
export const Violet008 = "rgba(139, 92, 246, 0.08)";

export const Cyan = "#06B6D4";

export const Red = "#ff3344";

export const DarkOrange01 = "rgb(234,97,49, 0.1)";
export const DarkOrange03 = "rgb(234,97,49, 0.3)";
export const DarkOrange05 = "rgb(234,97,49, 0.5)";
export const DarkOrange07 = "rgb(234,97,49, 0.7)";
export const DarkOrange09 = "rgb(234,97,49, 0.9)";

export const Green03 = "rgb(10,64,45,0.3)";
export const Orange03 = "rgb(231,142,55,0.3)";
export const Burgundy03 = "rgb(80,28,44,0.3)";

export const Black005 = "rgba(0, 0, 0, 0.05)";
export const Black09 = "rgba(0, 0, 0, 0.9)";
export const Black07 = "rgba(0, 0, 0, 0.7)";
export const Black05 = "rgba(0, 0, 0, 0.5)";
export const Black03 = "rgba(0, 0, 0, 0.3)";
export const Black01 = "rgba(0, 0, 0, 0.1)";

export const White01 = "rgba(255, 255, 255, 0.1)";
export const White02 = "rgba(255, 255, 255, 0.2)";
export const White03 = "rgba(255, 255, 255, 0.3)";
export const White05 = "rgba(255, 255, 255, 0.5)";
export const White07 = "rgba(255, 255, 255, 0.7)";
export const White08 = "rgba(255, 255, 255, 0.8)";

export const White = "#fff";
export const Black = "#000";

export const PageGradient =
  "linear-gradient(to bottom, #000000, rgb(2, 0, 36))";

export const gradientColors = {
  "personality-check": { background: Blue, transitionBackground: Purple },
  "sex-styles": { background: Pink, transitionBackground: Blue },
  "political-alignment": {
    background: Yellow,
    transitionBackground: Orange,
  },
  "best-date": { background: Red, transitionBackground: Pink },
  "attachment-styles": { background: Purple, transitionBackground: Pink },
  // Non-core quiz
  "am-i-gay": { background: DarkPink, transitionBackground: DeepBlue },
  "affection-profile": { background: Red, transitionBackground: Purple },
  "love-languages": { background: Pink, transitionBackground: Red },
};
